import { Text } from 'app/design/primitives/text';
import { Trans } from 'react-i18next';

export function LostSuperProgress({ completed, lostSuper }: { completed: number; lostSuper: boolean }) {
  if (!lostSuper) return null;

  const progressKey = completed === 1 ? 'progress.one' : completed === 2 ? 'progress.two' : 'description.isNowSuper';
  return (
    <Text fontSize={16} fontWeight="700">
      <Trans components={{ strong: <Text fontWeight="700" /> }} i18nKey={progressKey} ns="superPartageurNotification" />
    </Text>
  );
}
